module.exports = __webpack_public_path__ + "static/media/elixir-printing-img-1.ba9bf639.jpg";